import { Controller } from "stimulus";
import Swiper from "swiper";
// Fix the import paths for Swiper 7
import { Navigation, Pagination } from "swiper";

// Import Swiper styles
import "swiper/swiper.min.css";

// Register modules
Swiper.use([Navigation, Pagination]);

// Register Swiper modules - this is the missing line
Swiper.use([Navigation, Pagination]);

export default class extends Controller {
  static targets = ["container", "pagination", "prevButton", "nextButton"];

  connect() {
    console.log("Swiper controller connected");
    this.initSwiper();
  }

  initSwiper() {
    this.swiper = new Swiper(this.containerTarget, {
      // Optional parameters
      loop: true,
      effect: "slide",
      speed: 700,

      // If we need pagination
      pagination: {
        el: this.paginationTarget,
        clickable: true,
      },

      // Navigation arrows
      navigation: {
        nextEl: this.nextButtonTarget,
        prevEl: this.prevButtonTarget,
      },
    });
  }

  disconnect() {
    if (this.swiper) {
      this.swiper.destroy();
    }
  }
}
